import ApiService from './ApiService';
import { ReviewSerializer } from './serializers';

class ReviewService extends ApiService {
  constructor(session) {
    super(session);

    this.url = '/reviews';
  }

  getAll() {
    return super.get(`${this.url}.json`,
      (response) => response.map(item => ReviewSerializer.deserialize(item)));
  }

  update(review) {
    return super.patch(`${this.url}/${review.id}.json`, { review: ReviewSerializer.serialize(review) }, () => { });
  }
}

export default ReviewService;